import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type {
    OrderGroupId} from "@@/shared/order-groups/order-group-id";
import {
    orderGroupIdZodSchema,
} from "@@/shared/order-groups/order-group-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { OrderId} from "./order-id";
import { orderIdZodSchema } from "./order-id";

type OrderRevertFulfilledRequest = {
    readonly _id: string;
    readonly _type: "ORDER_REVERT_FULFILLED_REQUEST";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly orderGroupId: OrderGroupId;
    readonly orderId: OrderId;
};

type FactoryParams = Except<
    OrderRevertFulfilledRequest,
    "_id" | "_type" | "_createdAt"
>;
const orderRevertFulfilledRequestFactory = (params: FactoryParams) => {
    const orderRevertFulfilled: OrderRevertFulfilledRequest = {
        ...params,
        _id: generateId({ prefix: "order_revert_fulfilled_request__" }),
        _type: "ORDER_REVERT_FULFILLED_REQUEST",
        _createdAt: nowIsoAndUnix(),
    };
    return orderRevertFulfilled;
};

const orderRevertFulfilledRequestZodSchema: z.ZodSchema<OrderRevertFulfilledRequest> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("ORDER_REVERT_FULFILLED_REQUEST"),
        _createdAt: isoAndUnixZodSchema,
        orderGroupId: orderGroupIdZodSchema,
        orderId: orderIdZodSchema,
    });

export {
    orderRevertFulfilledRequestFactory,
    orderRevertFulfilledRequestZodSchema,
};
export type { OrderRevertFulfilledRequest };
